<template>
  <header class="curation-header">
    <div
      class="representative-image"
      v-if="curation.image"
      @click="showImageModal()"
    >
      <UiImageSelection :image="curation.image" :info="true" :fullsize="true" />
      <CurationModal ref="curationModal" />
    </div>
    <BaseSectionContainer
      tag="div"
      size="middle"
      class="title-area"
    >
      <BaseDropdown v-if="parentCuration" position="bottom-right">
        <template #trigger="">
          <a class="jps-parent-title is-size-6">{{
            ls(parentCuration.title)
          }}</a>
        </template>
        <BaseDropdownItem :link="true">
          <CurationMediaBlock :curation="parentCuration" />
        </BaseDropdownItem>
        <BaseDropdownItem :link="true" v-for="n in pageLength" :key="n">
          <CurationMediaBlock
            :curation="parentCuration"
            :page="n"
          />
        </BaseDropdownItem>
      </BaseDropdown>
      <h1
        class="jps-curation-title is-size-3-desktop is-size-5-touch has-text-weight-bold"
      >
        {{ ls(curation.title) }}
      </h1>
      <p
        class="jps-curation-yomi is-size-7"
        v-if="isJa"
        aria-hidden="true"
      >
        {{ curation.title.yomi }}
      </p>
      <p class="jps-curation-summary is-size-6-desktop is-size-7-touch">
        {{ ls(curation.summary) }}
      </p>
    </BaseSectionContainer>
  </header>
</template>

<script lang="ts" setup>
import type { CurationModal } from '#components'

const { ls, isJa } = useI18n()
const { imageSelection2ModalInfo } = useCurationModal()

interface Props {
  parentCuration: Curation
  curation: Curation
}
const props = withDefaults(defineProps<Props>(), {})

const curationModal = ref<InstanceType<typeof CurationModal>>()
const showImageModal = async () => {
  try {
    await curationModal.value.openAwait({
      info: imageSelection2ModalInfo(props.curation.image)
    },
    {
      animation: 'slideY',
    })
  } catch (cancel) {}
}

const pageLength = computed(() => {
  if (props.parentCuration && props.parentCuration.subPages)
    return props.parentCuration.subPages.length
  return 0
})
</script>

<style lang="scss" scoped>
@use '@/assets/styles/scss/vue' as *;

.curation-header {
  @include typo-paragraph();
  .representative-image {
    height: 512px;
    width: 100%;
    text-align: center;
    .jps-image-selection {
      background: $black;
    }
  }
  /* mobileの場合には16:9で固定 */
  @include is-mobile {
    .representative-image {
      height: unset;
      @include ratio16x9Wrapper;
      .jps-image-selection {
        @include ratioInner;
      }
    }
  }
  .title-area {
    // @include global-width-strict();
    @include is-mobile {
      margin: 1rem;
    }
    div.ui-base-dropdown {
      // BaseDropdownのwidth: min-contentを上書き
      width: auto;
    }
    a.jps-parent-title {
      display: inline-block;
      padding-bottom: 1rem;
    }
  }
  .front {
    z-index: 100;
  }
  .title,
  .subtitle {
    color: $white;
    text-align: center;
  }
  .title {
    margin-top: 2rem;
    margin-bottom: 3rem;
  }
  .sub {
    padding: 0.5rem;
  }
  .jps-curation-summary {
    margin: 1rem 0;
  }
}
</style>
